<template>
	<div class="sale-view">
		<b-card-group>
			<b-card header-tag="header" footer-tag="footer" class="saleViewCard">
				<div slot="header" class="top-card">
					<span class="hide-print">
						<h5>Продажа <strong> №:{{ item.saleNumber}}</strong> - {{ item.shopName }}</h5>
					</span>
					<a style="font-size: 16px;" class="mr-3" :href="`${root_api}/excel-parser/list-from-sale-optom/${item.id}`" disabled
								download>{{ $t('excel-export.download-excel') }}</a>
				</div>
				<div class="box box-solid">
					<div class="box-body">
						<div class="row">
							<div :class="[item.action == 'OPTOM_SAVDO' ? 'col-sm-4 pr-0' : 'col-sm-5 pr-0']">
								<span :class="[item.action == 'OPTOM_SAVDO' ? 'pr-2' : 'pr-4']"><strong>Дата:</strong> {{ item.saleDate}} </span>
								<span><strong>Кассир:</strong> {{ item.cashierFullName}} </span>
							</div>
							<div class="col-sm-2 pl-0">
								<strong>Сумма: </strong>{{ item.amountOfPaymentUzs | currency({
								symbol:
								currencyForSaleView, fractionCount: 2, symbolPosition: 'back'
								}) }}
							</div>
							<div class="col-sm-3 pl-0">
								<strong>Сумма со скидкой: </strong>{{ item.amountOfAfterPromoUzs | currency({
								symbol:
								currencyForSaleView, fractionCount: 2, symbolPosition: 'back'
								}) }}<br>
							</div>
							<div class="col-sm-3 pl-0" v-if="item.action == 'OPTOM_SAVDO'">
								<strong>{{ $t('pos.discountForEachItem') }}: </strong>{{ afterPromotionSum(item.saleItems[0]) > 0 ?
								afterPromotionSum(item.saleItems[0]) : afterPromotionPercentage(item.saleItems[0]) }}
								{{ afterPromotionSum(item.saleItems[0]) > 0 ? currencyForSaleView : '%' }}<br>
							</div>
							<div class="col-sm-2 pl-0" v-else>
								<strong>Скидка (на чек): </strong>{{ item.customPromotionDiscount ?
								item.customPromotionDiscount : 0 }} {{ item.customPromotionType == '%' ? '%' : currencyForSaleView }}<br>
							</div>
						</div>
						<div class="row">
							<div class="col-12">
								<strong>{{ $t('contract.comment') }}: </strong><span>{{ item.comment }}</span>
							</div>
						</div>
					</div>
				</div>
				<hr class="mt-1 mb-1">
				<b-table class="generalTableClass"
						 striped="striped"
						 bordered="bordered"
						 small="small"
						 fixed="fixed"
						 :items="item.saleItems"
						 responsive="sm"
						 :fields="computedFields"
				>
					<template slot="id" slot-scope="data">
						{{ data.index + 1 }}
					</template>
					<template slot="Продукт" slot-scope="data">
						{{data.item.name ? data.item.name : '' }} / <strong>{{ data.item.artikul }}</strong> / {{
						data.item.size }}
					</template>
					<template slot="barcode" slot-scope="data">
						<strong>{{ data.item.barcode }}</strong>
					</template>
					<template slot="color" slot-scope="data">
						<strong>{{ data.item.colorName }}</strong>
					</template>
					<template slot="count" slot-scope="data">
						{{ data.item.count }} {{ data.item.unitName }}
					</template>

					<!-- <template slot="weight" slot-scope="data">
						{{ data.item.weight > 0 ? data.item.weight : '-' }}
					</template>
					<template slot="inWrapped" slot-scope="data">
						{{ data.item.wrapped ? getWrappedItemsAmount(data.item.wrappedItems) : '-' }}
					</template>
					<template slot="inWrappedTotal" slot-scope="data">
						{{ data.item.wrapped ? getWrappedItemsAmount(data.item.wrappedItems) * data.item.count : '-' }}
					</template> -->

					<template slot="price" slot-scope="data">
						{{ data.item.priceWholesale | currency({symbol: currencyForSaleView, fractionCount: 2, symbolPosition: 'back'}) }}
					</template>
					<template slot="pul" slot-scope="data">
						{{ afterPromotionSum(data.item) | currency({symbol: currencyForSaleView, fractionCount: 2, symbolPosition: 'back'}) }}
					</template>
					<template slot="percentage" slot-scope="data">
						{{ afterPromotionPercentage(data.item) }} %
					</template>
					<template slot="discountPriceUzs" slot-scope="data">
						{{data.item.discountPriceUzs | currency({
						symbol: currencyForSaleView, fractionCount: 2, symbolPosition:
						'back'
						}) }}
					</template>
				</b-table>
			</b-card>
		</b-card-group>
	</div>
</template>
<script>

    export default {
        name: 'SaleView',
        props: ['item', 'currencyForSaleView'],
        data() {
            return {
				root_api: process.env.VUE_APP_ROOT_API
			}
        },
        computed: {
            computedFields() {
                return [
                    {
                        key: 'id',
                        label: '№',
                        sortable: true,
                        class: 'saleViewId'
                    },
                    {
                        key: 'Продукт',
                        label: 'Продукт',
                        sortable: true,
                        class: 'width15_wordBreak'
                    },
                    {
                        key: 'barcode',
                        label: 'Штрихкод',
                        sortable: true
                    },
                    {
                        key: 'color',
                        label: 'Цвет',
                        sortable: true
                    },
                    {
                        key: 'count',
                        label: 'Кол-во',
                        sortable: true,
                        'class': 'textAlignCenter'
                    },
										// {
										// 	key: 'weight',
										// 	label: this.$t('pos.weight'),
										// 	'class': 'saleItemWeight width5',
										// },
										// {
										// 	key: 'inWrapped',
										// 	label: this.$t('pos.inWrapped'),
										// 	'class': 'saleItemWrapped width6_wordBreak',
										// },
										// {
										// 	key: 'inWrappedTotal',
										// 	label: this.$t('pos.inWrappedTotal'),
										// 	'class': 'saleItemWrappedTotal width6_wordBreak',
										// },
                    {
                        key: 'price',
                        label: 'Цена',
                        'class': 'textAlignCenter'
                    },
                    {
                        key: 'pul',
                        label: 'Скидка'
                    },
                    {
                        key: 'percentage',
                        label: 'Скидка %'
                    },
                    {
                        key: 'discountPriceUzs',
                        label: 'Цена со скидкой',
                        'class': 'textAlignCenter'
                    },
                ]
            },
        },
        methods: {
					getWrappedItemsAmount(wrappedItems) {
						let inWrappedAmount = 0;
						if (wrappedItems) {
							wrappedItems.forEach(item => inWrappedAmount += item.amount)
						}
						return inWrappedAmount;
					},
            afterPromotionSum(item) {
                let promoparam;
                if (item.promotions) {
                    for (let i = 0; i < item.promotions.length; i++) {
                        if (item.promotions[i].type == "PUL") {
                            promoparam = item.promotions[i].value
                        }
                    }
                    return promoparam;
                }

            },

            afterPromotionPercentage(item) {
                let promoparam1;
                if (item.promotions) {
                    for (let i = 0; i < item.promotions.length; i++) {
                        if (item.promotions[i].type == "%") {
                            promoparam1 = item.promotions[i].value
                        }
                    }
                    return promoparam1;

                }
            },
        }
    }
</script>
<style scoped lang="scss">
	.top-card {
		display: flex;
		justify-content: space-between;
		align-item: center;
	}

	.saleViewCard {
		min-height: unset;
	}

	.generalTableClass {
		table {
			th.productInfo {
				width: 21% !important;
			}
		}
	}
</style>
